/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Footnote_UsersInputs */



/**
* | output |
* | --- |
* | "*** Pro accounts include one user. Additional users cost $5/month per active user." |
*
* @param {Signup_Footnote_UsersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_footnote_users = /** @type {((inputs?: Signup_Footnote_UsersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Footnote_UsersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("*** Pro accounts include one user. Additional users cost $5/month per active user.")
	if (locale === "de") return /** @type {LocalizedString} */ ("*** Pro accounts include one user. Additional users cost $5/month per active user.")
	if (locale === "it") return /** @type {LocalizedString} */ ("*** Pro accounts include one user. Additional users cost $5/month per active user.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("*** Pro accounts include one user. Additional users cost $5/month per active user.")
	if (locale === "es") return /** @type {LocalizedString} */ ("*** Pro accounts include one user. Additional users cost $5/month per active user.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("*** Pro accounts include one user. Additional users cost $5/month per active user.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("*** Pro accounts include one user. Additional users cost $5/month per active user.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("*** Pro accounts include one user. Additional users cost $5/month per active user.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("*** Pro accounts include one user. Additional users cost $5/month per active user.")
	return /** @type {LocalizedString} */ ("*** Pro accounts include one user. Additional users cost $5/month per active user.")
});